// extracted by mini-css-extract-plugin
export default {"ModalAnimation":"TIaZOqDAlZhP7PeNbaqL"};